export const translations = {
  es: {
    brand: {
      name: 'DermaLipo',
      city: 'Phoenix',
      tagline: 'Una experiencia estética de lujo en Scottsdale.',
    },
    nav: {
      benefits: 'La Experiencia',
      process: 'El Proceso',
      areas: 'Zonas',
      doctor: 'Tu Especialista',
      testimonials: 'Transformaciones',
      faq: 'Preguntas',
      contact: 'Consulta Privada',
      cta: 'Solicita tu Consulta',
    },
    hero: {
      badge: 'Por cita · Scottsdale, AZ',
      eyebrow: 'CONTORNO CORPORAL DE AUTOR',
      headline: 'Vuelve a sentirte tú.',
      sublineEmotional:
        'Recupera la mujer que siempre has sido — con la elegancia, la confianza y la silueta que mereces.',
      highlight: 'sin cirugía',
      subheadline:
        'En DermaLipo Phoenix esculpimos tu figura y reafirmamos tu piel con elegancia, discreción y resultados naturales. Una transformación pensada solo para ti.',
      cta: 'Solicita tu Consulta Privada',
      ctaSecondary: 'Conoce la experiencia',
      trust1: 'Sin cirugía mayor',
      trust2: 'Sin anestesia general',
      trust3: 'Resultados naturales',
      socialProof: 'Cientos de mujeres transformadas',
      rating: 'Atención concierge bilingüe',
      doctorCardCredentials: 'MD · Johns Hopkins',
      doctorCardTagline:
        'Armonía, seguridad y resultados que se ven naturalmente bellos.',
    },
    benefits: {
      eyebrow: 'LA EXPERIENCIA',
      heading: 'Un enfoque profundamente humano para tu transformación',
      subheading:
        'Cada detalle ha sido pensado para que te sientas vista, cuidada y restaurada.',
      items: [
        {
          title: 'Esculpido con naturalidad',
          desc: 'Moldea tu figura manteniendo la armonía y proporción natural de tu cuerpo. Nada exagerado. Solo tú, refinada.',
          key: 'natural',
        },
        {
          title: 'Una silueta visiblemente refinada',
          desc: 'Reducción de medidas elegante y efectiva desde la primera sesión. La diferencia se ve. Y se siente.',
          key: 'inches',
        },
        {
          title: 'Retoma tu vida, con elegancia',
          desc: 'Un procedimiento diseñado para que vuelvas a tu rutina sin interrupciones. Sin pausas largas. Sin esconderte.',
          key: 'recovery',
        },
        {
          title: 'Despierta. En calma. En control.',
          desc: 'Una experiencia tranquila y segura, con anestesia local únicamente. Acompañada en todo momento.',
          key: 'safe',
        },
        {
          title: 'Tu piel permanece intacta',
          desc: 'Técnicas mínimamente invasivas que respetan la integridad de tu piel. Sin cicatrices visibles.',
          key: 'smooth',
        },
        {
          title: 'Planes de inversión a medida',
          desc: 'Opciones de financiamiento discretas, flexibles y adaptadas a ti. Tu transformación, a tu ritmo.',
          key: 'financing',
        },
      ],
    },
    process: {
      eyebrow: 'TU CAMINO',
      heading: 'Cuatro pasos. Una mujer transformada.',
      subheading:
        'Una experiencia diseñada con calma, claridad y atención personalizada.',
      steps: [
        {
          number: '01',
          title: 'Consulta Privada',
          desc: 'Una conversación íntima sobre tus objetivos, tu cuerpo y tu visión. Sin presión. Sin compromiso.',
        },
        {
          number: '02',
          title: 'Plan Personalizado',
          desc: 'Tu especialista diseña un protocolo único para ti — basado en tu anatomía y tu vida.',
        },
        {
          number: '03',
          title: 'Tu Transformación',
          desc: 'Un procedimiento sereno, en un espacio privado, con atención concierge bilingüe en todo momento.',
        },
        {
          number: '04',
          title: 'Recuperación con Cuidado',
          desc: 'Acompañamiento continuo, seguimiento personalizado y resultados que mejoran con el tiempo.',
        },
      ],
    },
    areas: {
      eyebrow: 'ZONAS',
      heading: 'Esculpe la silueta que imaginas',
      subheading:
        'Cada zona, perfeccionada con precisión y respeto por tu cuerpo.',
      items: [
        { name: 'Espalda', key: 'back' },
        { name: 'Abdomen', key: 'abdomen' },
        { name: 'Flancos', key: 'flanks' },
        { name: 'Piernas', key: 'legs' },
        { name: 'Glúteos', key: 'glutes' },
        { name: 'Papada', key: 'chin' },
        { name: 'Brazos', key: 'arms' },
        { name: 'Pechos', key: 'chest' },
      ],
    },
    doctor: {
      eyebrow: 'TU ESPECIALISTA',
      name: 'Dr. Anil Kashyap',
      credentials: ['MD', 'DDS', 'MSc'],
      bio: 'Cirujano plástico con doble titulación y especialización en microcirugía reconstructiva por la Universidad Johns Hopkins. Más de una década perfeccionando el contorno corporal con un único principio: armonía, seguridad y resultados que se ven naturales. En DermaLipo Phoenix, combina la precisión académica con una mirada estética profundamente humana.',
      ctaText: 'Conoce su filosofía',
      institutions: [
        'Johns Hopkins',
        'University of Oklahoma',
        'VA Healthcare System',
      ],
    },
    authority: {
      eyebrow: 'POR QUÉ DERMALIPO PHOENIX',
      heading: 'Una práctica boutique. Una atención sin comparación.',
      stats: [
        { value: '500+', label: 'Mujeres transformadas' },
        { value: '10+', label: 'Años de experiencia' },
        { value: '99%', label: 'Satisfacción' },
        { value: '4.9', label: 'Valoración promedio' },
      ],
      pillars: [
        {
          title: 'Cirujano de elite',
          desc: 'Formado en Johns Hopkins. Certificado. Reconocido por sus resultados naturales.',
        },
        {
          title: 'Atención concierge bilingüe',
          desc: 'Te acompañamos en español o inglés. Antes, durante y después de tu transformación.',
        },
        {
          title: 'Financiamiento flexible',
          desc: 'Trabajamos con Cherry, CareCredit, Affirm y Alphaeon. Tu transformación, a tu ritmo.',
        },
        {
          title: 'Privacidad absoluta',
          desc: 'Un estudio privado en Scottsdale. Discreción y elegancia en cada visita.',
        },
      ],
      financingTitle: 'Aceptamos los principales planes de financiamiento',
      financing: ['Cherry', 'CareCredit', 'Affirm', 'Alphaeon'],
    },
    testimonials: {
      eyebrow: 'TRANSFORMACIONES',
      heading: 'Mujeres reales. Resultados naturales.',
      subheading: 'Documentado con discreción. Compartido con consentimiento.',
      before: 'Antes',
      after: 'Después',
      session: '1 Sesión',
      categories: {
        all: 'Todas',
        abdomen: 'Abdomen',
        flanks: 'Flancos',
        arms: 'Brazos',
        chin: 'Papada',
      },
      privacyNote:
        'Imágenes utilizadas con consentimiento expreso de cada paciente.',
    },
    faq: {
      eyebrow: 'PREGUNTAS FRECUENTES',
      heading: 'Lo que querías saber, respondido con claridad.',
      subheading:
        'Y si tu pregunta no está aquí, la responderemos en tu consulta privada.',
      items: [
        {
          q: '¿Soy candidata para Lipolaser?',
          a: 'La mayoría de mujeres entre 25 y 65 años con grasa localizada y buena salud general son candidatas. En tu consulta privada evaluaremos tu caso de forma individual para confirmarlo.',
        },
        {
          q: '¿Cómo es la recuperación?',
          a: 'La mayoría de nuestras pacientes regresan a sus actividades normales en 24-48 horas. Recibirás un protocolo de recuperación personalizado y acompañamiento continuo del equipo.',
        },
        {
          q: '¿Cuáles son las opciones de financiamiento?',
          a: 'Trabajamos con Cherry, CareCredit, Affirm y Alphaeon Credit. Ofrecemos planes flexibles, discretos y con aprobación rápida — incluso sin afectar tu puntaje de crédito.',
        },
        {
          q: '¿Es seguro?',
          a: 'El Lipolaser es uno de los procedimientos no quirúrgicos más seguros del mundo. Se realiza con anestesia local únicamente y bajo la supervisión directa del Dr. Kashyap, formado en Johns Hopkins.',
        },
        {
          q: '¿Atienden en español?',
          a: 'Sí. Todo nuestro equipo es bilingüe (español e inglés). Tu consulta, procedimiento y seguimiento se realizan en el idioma que prefieras.',
        },
        {
          q: '¿Qué pasa en mi consulta privada?',
          a: 'Es una conversación íntima de 30-45 minutos. Hablamos de tus objetivos, evaluamos las zonas a tratar, te explicamos las opciones y te entregamos un plan personalizado. Sin presión. Sin compromiso.',
        },
        {
          q: '¿Cuánto cuesta?',
          a: 'Cada transformación es única. El precio depende de las zonas tratadas y tu plan personalizado. Te entregaremos una propuesta clara y detallada al final de tu consulta privada.',
        },
        {
          q: '¿Cuándo veré resultados?',
          a: 'Verás cambios visibles desde la primera sesión. Los resultados continúan mejorando durante las siguientes 6-12 semanas mientras tu cuerpo se ajusta naturalmente.',
        },
      ],
    },
    location: {
      eyebrow: 'EL ESTUDIO',
      heading: 'Phoenix, Arizona',
      subheading: 'Un espacio privado en el corazón de Scottsdale.',
      address: '10505 N 69th St Suite 1100, Scottsdale, AZ, 85253',
      addressLabel: 'DIRECCIÓN',
      phoneLabel: 'TELÉFONO',
      emailLabel: 'EMAIL',
    },
    contact: {
      eyebrow: 'CONSULTA PRIVADA',
      heading: 'Tu transformación comienza aquí.',
      subhead:
        'Una conversación privada con tu especialista. Un plan diseñado para ti. Sin compromiso.',
      urgency:
        'Aceptamos un número limitado de consultas cada semana para asegurar una atención verdaderamente personalizada.',
      benefits: [
        'Una sesión privada con tu especialista',
        'Un plan de transformación diseñado para ti',
        'Opciones de financiamiento confidenciales',
        'Una respuesta dentro de 24 horas',
      ],
      trust: {
        secure: 'Confidencial',
        response: 'Atención Concierge',
        bilingual: 'Bilingüe',
      },
      financingNote:
        'Pre-aprobación de financiamiento disponible. Sin afectar tu puntaje de crédito.',
    },
    stickyCta: {
      text: 'Consulta Privada',
      button: 'Solicitar',
    },
    footer: {
      tagline: 'Elegancia, confianza y una silueta refinada.',
      quickLinks: 'Navegación',
      legal: 'Legal',
      rights: '© 2026 DermaLipo Phoenix. Todos los derechos reservados.',
      disclaimer:
        'Los resultados varían entre cada paciente. Las imágenes utilizadas representan casos reales con consentimiento expreso.',
      links: {
        privacy: 'Privacidad',
        terms: 'Términos',
        cookies: 'Cookies',
        patient: 'Derechos del Paciente',
      },
    },
  },
  en: {
    brand: {
      name: 'DermaLipo',
      city: 'Phoenix',
      tagline: 'A luxury aesthetic experience in Scottsdale.',
    },
    nav: {
      benefits: 'The Experience',
      process: 'The Process',
      areas: 'Areas',
      doctor: 'Your Specialist',
      testimonials: 'Transformations',
      faq: 'Questions',
      contact: 'Private Consultation',
      cta: 'Request Consultation',
    },
    hero: {
      badge: 'By appointment · Scottsdale, AZ',
      eyebrow: 'SIGNATURE BODY CONTOURING',
      headline: 'Feel like yourself again.',
      sublineEmotional:
        'Reclaim the woman you have always been — with the confidence, elegance and silhouette you deserve.',
      highlight: 'without surgery',
      subheadline:
        'At DermaLipo Phoenix, we sculpt your figure and firm your skin with elegance, discretion and natural-looking results. A transformation crafted only for you.',
      cta: 'Request Your Private Consultation',
      ctaSecondary: 'Discover the experience',
      trust1: 'No major surgery',
      trust2: 'No general anesthesia',
      trust3: 'Naturally refined results',
      socialProof: 'Hundreds of women transformed',
      rating: 'Bilingual concierge care',
      doctorCardCredentials: 'MD · Johns Hopkins',
      doctorCardTagline: 'Harmony, safety, and naturally beautiful results.',
    },
    benefits: {
      eyebrow: 'THE EXPERIENCE',
      heading: 'A deeply human approach to your transformation',
      subheading:
        'Every detail crafted to make you feel seen, cared for, and restored.',
      items: [
        {
          title: 'Naturally sculpted',
          desc: "Shape your figure while preserving your body's natural harmony and proportions. Nothing overdone. Just you, refined.",
          key: 'natural',
        },
        {
          title: 'A visibly refined silhouette',
          desc: 'Elegant, effective measurement reduction from the very first session. You see the difference. You feel it.',
          key: 'inches',
        },
        {
          title: 'Resume your life, beautifully',
          desc: 'A procedure designed so you return to your routine without interruption. No long pauses. No hiding.',
          key: 'recovery',
        },
        {
          title: 'Awake. Calm. In control.',
          desc: 'A tranquil, safe experience with local anesthesia only. Accompanied at every step.',
          key: 'safe',
        },
        {
          title: 'Your skin remains untouched',
          desc: 'Minimally invasive techniques that respect the integrity of your skin. No visible scarring.',
          key: 'smooth',
        },
        {
          title: 'Investment plans, tailored',
          desc: 'Discreet, flexible financing options crafted around you. Your transformation, at your pace.',
          key: 'financing',
        },
      ],
    },
    process: {
      eyebrow: 'YOUR JOURNEY',
      heading: 'Four steps. One transformed woman.',
      subheading:
        'An experience designed with calm, clarity and personal attention.',
      steps: [
        {
          number: '01',
          title: 'Private Consultation',
          desc: 'An intimate conversation about your goals, your body, your vision. No pressure. No obligation.',
        },
        {
          number: '02',
          title: 'Personalized Plan',
          desc: 'Your specialist designs a protocol unique to you — based on your anatomy and your lifestyle.',
        },
        {
          number: '03',
          title: 'Your Transformation',
          desc: 'A serene procedure, in a private setting, with bilingual concierge care every step of the way.',
        },
        {
          number: '04',
          title: 'Recovery, Cared For',
          desc: 'Continuous support, personalized follow-up, and results that refine beautifully over time.',
        },
      ],
    },
    areas: {
      eyebrow: 'AREAS',
      heading: 'Sculpt the silhouette you envision',
      subheading:
        'Each area perfected with precision and reverence for your body.',
      items: [
        { name: 'Back', key: 'back' },
        { name: 'Abdomen', key: 'abdomen' },
        { name: 'Flanks', key: 'flanks' },
        { name: 'Legs', key: 'legs' },
        { name: 'Glutes', key: 'glutes' },
        { name: 'Chin', key: 'chin' },
        { name: 'Arms', key: 'arms' },
        { name: 'Chest', key: 'chest' },
      ],
    },
    doctor: {
      eyebrow: 'YOUR SPECIALIST',
      name: 'Dr. Anil Kashyap',
      credentials: ['MD', 'DDS', 'MSc'],
      bio: 'Dual-degree plastic surgeon with reconstructive microsurgery fellowship from Johns Hopkins University. Over a decade refining body contouring around a single principle: harmony, safety, and results that look effortlessly natural. At DermaLipo Phoenix, he brings academic precision together with a deeply human aesthetic sensibility.',
      ctaText: 'Discover his philosophy',
      institutions: [
        'Johns Hopkins',
        'University of Oklahoma',
        'VA Healthcare System',
      ],
    },
    authority: {
      eyebrow: 'WHY DERMALIPO PHOENIX',
      heading: 'A boutique practice. An incomparable level of care.',
      stats: [
        { value: '500+', label: 'Women transformed' },
        { value: '10+', label: 'Years of experience' },
        { value: '99%', label: 'Satisfaction' },
        { value: '4.9', label: 'Average rating' },
      ],
      pillars: [
        {
          title: 'Elite surgeon',
          desc: 'Johns Hopkins trained. Board-certified. Known for naturally beautiful results.',
        },
        {
          title: 'Bilingual concierge care',
          desc: 'We accompany you in Spanish or English. Before, during and after your transformation.',
        },
        {
          title: 'Flexible financing',
          desc: 'We partner with Cherry, CareCredit, Affirm and Alphaeon. Your transformation, at your pace.',
        },
        {
          title: 'Absolute privacy',
          desc: 'A private studio in Scottsdale. Discretion and elegance on every visit.',
        },
      ],
      financingTitle: 'We accept the leading financing partners',
      financing: ['Cherry', 'CareCredit', 'Affirm', 'Alphaeon'],
    },
    testimonials: {
      eyebrow: 'TRANSFORMATIONS',
      heading: 'Real women. Naturally beautiful results.',
      subheading: 'Discreetly documented. Shared with consent.',
      before: 'Before',
      after: 'After',
      session: '1 Session',
      categories: {
        all: 'All',
        abdomen: 'Abdomen',
        flanks: 'Flanks',
        arms: 'Arms',
        chin: 'Chin',
      },
      privacyNote: 'Images shared with express consent from each patient.',
    },
    faq: {
      eyebrow: 'FREQUENT QUESTIONS',
      heading: 'What you wanted to ask, answered with clarity.',
      subheading:
        'And if your question is not here, we will answer it in your private consultation.',
      items: [
        {
          q: 'Am I a candidate for Lipolaser?',
          a: 'Most women between 25 and 65 with localized fat and good general health are candidates. In your private consultation we evaluate your case individually to confirm.',
        },
        {
          q: 'What is recovery like?',
          a: 'Most of our patients return to normal activities within 24-48 hours. You will receive a personalized recovery protocol and continuous support from our team.',
        },
        {
          q: 'What are the financing options?',
          a: 'We partner with Cherry, CareCredit, Affirm and Alphaeon Credit. Flexible, discreet plans with fast approval — many without affecting your credit score.',
        },
        {
          q: 'Is it safe?',
          a: 'Lipolaser is one of the safest non-surgical contouring procedures available. It is performed under local anesthesia only and directly supervised by Dr. Kashyap, trained at Johns Hopkins.',
        },
        {
          q: 'Do you offer bilingual care?',
          a: 'Yes. Our entire team is bilingual (English and Spanish). Your consultation, procedure and follow-up are delivered in the language you prefer.',
        },
        {
          q: 'What happens during my private consultation?',
          a: 'An intimate 30-45 minute conversation. We discuss your goals, evaluate the areas, walk you through your options, and deliver a personalized plan. No pressure. No obligation.',
        },
        {
          q: 'How much does it cost?',
          a: 'Each transformation is unique. Pricing depends on the areas treated and your personalized plan. You receive a clear, detailed proposal at the end of your private consultation.',
        },
        {
          q: 'When will I see results?',
          a: 'Visible changes appear from the very first session. Results continue to refine over the following 6-12 weeks as your body naturally adjusts.',
        },
      ],
    },
    location: {
      eyebrow: 'THE STUDIO',
      heading: 'Phoenix, Arizona',
      subheading: 'A private space in the heart of Scottsdale.',
      address: '10505 N 69th St Suite 1100, Scottsdale, AZ, 85253',
      addressLabel: 'ADDRESS',
      phoneLabel: 'PHONE',
      emailLabel: 'EMAIL',
    },
    contact: {
      eyebrow: 'PRIVATE CONSULTATION',
      heading: 'Your transformation begins here.',
      subhead:
        'A private conversation with your specialist. A plan crafted just for you. No obligation.',
      urgency:
        'We accept a limited number of consultations each week to ensure truly personalized care.',
      benefits: [
        'A private session with your specialist',
        'A transformation plan crafted for you',
        'Confidential financing options',
        'A response within 24 hours',
      ],
      trust: {
        secure: 'Confidential',
        response: 'Concierge Care',
        bilingual: 'Bilingual',
      },
      financingNote:
        'Pre-approval financing available. Soft credit check — no impact to your credit score.',
    },
    stickyCta: {
      text: 'Private Consultation',
      button: 'Request',
    },
    footer: {
      tagline: 'Elegance, confidence, and a refined silhouette.',
      quickLinks: 'Navigation',
      legal: 'Legal',
      rights: '© 2026 DermaLipo Phoenix. All rights reserved.',
      disclaimer:
        'Individual results vary. Images depict actual patients shared with express consent.',
      links: {
        privacy: 'Privacy',
        terms: 'Terms',
        cookies: 'Cookies',
        patient: 'Patient Rights',
      },
    },
  },
}

export type Language = 'es' | 'en'
